/* ==========================================================================
   Lumen — quick-view.js
   Opens the global quick-view modal and fills it with the product's real
   buy-box. Fetches the full product page and extracts its <product-info>
   element (the proven, reliable method — a dedicated ?section_id= only
   renders sections that are placed in a template). product.js +
   section-main-product.css are lazy-loaded so the extracted markup drives
   variant selection / price / add-to-cart and is styled on any page.
   Progressive: the trigger is a real <a href> to the product, so with no JS
   (or if the shell is absent) the click just navigates.
   ========================================================================== */
(function () {
  'use strict';

  var modal = null;
  var content = null;
  var isOpen = false;

  function refs() {
    if (!modal) modal = document.getElementById('QuickViewModal');
    if (modal && !content) content = modal.querySelector('[data-quick-view-content]');
    return modal && content;
  }

  function lazyAsset(tag, attrUrl, marker, setup) {
    var url = modal && modal.getAttribute(attrUrl);
    if (!url || document.querySelector('[' + marker + ']')) return;
    var el = document.createElement(tag);
    el.setAttribute(marker, '');
    setup(el, url);
    document.head.appendChild(el);
  }
  function ensureProductJs() {
    if (window.customElements && customElements.get('product-info')) return;
    lazyAsset('script', 'data-product-js-url', 'data-quickview-product-js', function (s, url) { s.src = url; s.defer = true; });
  }
  function ensureProductCss() {
    lazyAsset('link', 'data-product-css-url', 'data-quickview-product-css', function (l, url) { l.rel = 'stylesheet'; l.href = url; });
  }
  function ensureVpJs() {
    // Bundle & volume-pricing controller (<volume-pricing> custom element).
    // Loading the script upgrades the injected element retroactively, so the
    // Bundle & save selector works inside quick view too.
    lazyAsset('script', 'data-vp-js-url', 'data-quickview-vp-js', function (s, url) { s.src = url; s.defer = true; });
  }

  function loadingMarkup() {
    return '<div class="quick-view__loading" role="status" aria-live="polite">' +
      '<span class="quick-view__spinner" aria-hidden="true"></span>' +
      '<span class="visually-hidden">Loading</span></div>';
  }
  function errorMarkup(url) {
    return '<div class="quick-view__error">' +
      '<p>Sorry — we couldn’t load a quick view here.</p>' +
      '<a class="btn btn--primary" href="' + url + '">View full details</a></div>';
  }

  /* Elements that don't belong in a compact quick view. Keep the delivery
     estimate; drop the trust badges (shown on the full page instead). */
  var TRIM = '.product-info__tab, .product-info__share, .product-trust-badges, .product-info__custom, [data-sticky-atc], [data-complementary]';

  function openQuickView(url) {
    if (!refs()) return;
    content.innerHTML = loadingMarkup();
    modal.open();
    isOpen = true;
    ensureProductJs();
    ensureProductCss();
    ensureVpJs();

    fetch(url.split('#')[0])
      .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('product-info');
        if (!node) throw new Error('no product-info');
        node.classList.add('quick-view__product');
        node.querySelectorAll(TRIM).forEach(function (el) { el.remove(); });

        content.innerHTML = '';
        content.appendChild(document.importNode(node, true));

        // A link back to the full product page.
        var info = content.querySelector('.product-layout__info') || content.firstElementChild;
        if (info) {
          var link = document.createElement('a');
          link.href = url;
          link.className = 'quick-view__full';
          link.textContent = 'View full details';
          info.appendChild(link);
        }

        var f = content.querySelector('a, button, select, input, [tabindex]');
        if (f) { try { f.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
      })
      .catch(function () { content.innerHTML = errorMarkup(url); });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view-url]');
    if (!trigger) return;
    var m = document.getElementById('QuickViewModal');
    if (!m || typeof m.open !== 'function') return; // shell not ready → let the link navigate
    e.preventDefault();
    modal = m;
    openQuickView(trigger.getAttribute('data-quick-view-url'));
  });

  /* When an add-to-cart succeeds, close quick view so the cart drawer takes over. */
  document.addEventListener('cart:updated', function () {
    if (isOpen && modal && typeof modal.close === 'function') modal.close();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dialog-close]')) isOpen = false;
  });
})();
